// Admin-Bereich (editor.bandeleart.ch/admin) – nur für BandeleArt.
// Zeigt je nach Zustand: Login, Übersicht aller Stammbäume oder den Admin-Editor.
// AdminApp.jsx – Routing: Login → Dashboard → Editor
import React, { useState } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import AdminEditor from './AdminEditor';

const API = 'https://editor.bandeleart.ch';

export default function AdminApp() {
  // Admin-Token (8 Stunden gültig) wird im Browser gemerkt, damit man nach einem
  // Neuladen eingeloggt bleibt.
  const [token, setToken] = useState(() => {
    try { return localStorage.getItem('admin_token') || null; } catch { return null; }
  });
  const [view, setView] = useState('dashboard'); // 'dashboard' | 'editor'
  const [selectedTree, setSelectedTree] = useState(null);

  const handleLogin = (newToken) => {
    try { localStorage.setItem('admin_token', newToken); } catch {}
    setToken(newToken);
  };

  const handleLogout = () => {
    try { localStorage.removeItem('admin_token'); } catch {}
    setToken(null);
    setView('dashboard');
    setSelectedTree(null);
  };

  const handleOpenTree = (tree) => {
    setSelectedTree(tree);
    setView('editor');
  };

  const handleBack = () => {
    setView('dashboard');
    setSelectedTree(null);
  };

  // Nicht eingeloggt → Login.
  if (!token) {
    return <AdminLogin api={API} onLogin={handleLogin} />;
  }

  if (view === 'editor' && selectedTree) {
    return (
      <AdminEditor
        api={API}
        token={token}
        tree={selectedTree}
        onBack={handleBack}
        onLogout={handleLogout}
      />
    );
  }

  return (
    <AdminDashboard
      api={API}
      token={token}
      onOpenTree={handleOpenTree}
      onLogout={handleLogout}
    />
  );
}
